export enum ViewVariant {
  DEFAULT = 'tile-medium',
  LIST = 'list',
  TILE_SMALL = 'tile-small',
  TILE_MEDIUM = DEFAULT,
  TILE_LARGE = 'tile-large',
}
